module.exports = __webpack_public_path__ + "static/img/yonggang_xiong_cert.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yonggang_xiong_cert.jpg
// module id = N8pC
// module chunks = 0